import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function StoreLayout({ children }) {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
